/* src/Ssids.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import { TableSort } from "../_snowpack/pkg/svelte-tablesort.js";
import Ssid from "./Ssid.svelte.js";

function create_thead_slot(ctx) {
	let tr;

	return {
		c() {
			tr = element("tr");

			tr.innerHTML = `<th>command</th> 
		<th data-sort="esp_ssid" data-sort-initial="descending">SSID</th> 
		<th data-sort="esp_signal">signal (RSSI)</th> 
		<th data-sort="esp_chan">channel</th> 
		<th data-sort="esp_enc_type">enc_type</th> 
		<th data-sort="esp_bssid">BSSID</th> 
		<th data-sort="wfm_last_seen_before">last seen (ms)</th> 
		<th>raw (json)</th>`;

			attr(tr, "slot", "thead");
		},
		m(target, anchor) {
			insert(target, tr, anchor);
		},
		d(detaching) {
			if (detaching) detach(tr);
		}
	};
}

// (37:1) 
function create_tbody_slot(ctx) {
	let tr;
	let ssid;
	let current;

	function close_other_handler() {
		return /*close_other_handler*/ ctx[3](/*item*/ ctx[4]);
	}

	ssid = new Ssid({
			props: {
				can_connect: /*can_connect*/ ctx[1],
				ssid: /*item*/ ctx[4]
			}
		});

	ssid.$on("close_other", close_other_handler);

	return {
		c() {
			tr = element("tr");
			create_component(ssid.$$.fragment);
			attr(tr, "slot", "tbody");
		},
		m(target, anchor) {
			insert(target, tr, anchor);
			mount_component(ssid, tr, null);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const ssid_changes = {};
			if (dirty & /*can_connect*/ 2) ssid_changes.can_connect = /*can_connect*/ ctx[1];
			if (dirty & /*item*/ 16) ssid_changes.ssid = /*item*/ ctx[4];
			ssid.$set(ssid_changes);
		},
		i(local) {
			if (current) return;
			transition_in(ssid.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ssid.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(tr);
			destroy_component(ssid);
		}
	};
}

function create_fragment(ctx) {
	let tablesort;
	let current;

	tablesort = new TableSort({
			props: {
				items: /*items*/ ctx[0],
				$$slots: {
					tbody: [
						create_tbody_slot,
						({ item }) => ({ 4: item }),
						({ item }) => item ? 16 : 0
					],
					thead: [create_thead_slot]
				},
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(tablesort.$$.fragment);
		},
		m(target, anchor) {
			mount_component(tablesort, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const tablesort_changes = {};
			if (dirty & /*items*/ 1) tablesort_changes.items = /*items*/ ctx[0];

			if (dirty & /*$$scope, can_connect, item*/ 50) {
				tablesort_changes.$$scope = { dirty, ctx };
			}

			tablesort.$set(tablesort_changes);
		},
		i(local) {
			if (current) return;
			transition_in(tablesort.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tablesort.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tablesort, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { items } = $$props;
	let { can_connect } = $$props;

	function close_other(except) {
		items.forEach(x => {
			if (x !== except) x.wfm_connection_dialog_open = false;
		});

		$$invalidate(0, items);
	}

	const close_other_handler = item => close_other(item);

	$$self.$$set = $$props => {
		if ("items" in $$props) $$invalidate(0, items = $$props.items);
		if ("can_connect" in $$props) $$invalidate(1, can_connect = $$props.can_connect);
	};

	return [items, can_connect, close_other, close_other_handler];
}

class Ssids extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { items: 0, can_connect: 1 });
	}
}

export default Ssids;